import { render } from "./ContactsList.vue?vue&type=template&id=389d76ca"
import script from "./ContactsList.vue?vue&type=script&lang=ts"
export * from "./ContactsList.vue?vue&type=script&lang=ts"
script.render = render

export default script